// Campus photo for /colleges/baylor-university: CC BY-SA 4.0, by Michael Barera, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABaylor_University_June_2016_18_(Founders_Mall_and_Pat_Neff_Hall).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/baylor-university/; credited under the photo.
const photo = {
    "slug": "baylor-university",
    "alt": "Founders Mall and the dome of Pat Neff Hall on the Baylor University campus in Waco, Texas",
    "src": "/colleges/baylor-university/campus-1600.webp",
    "srcSmall": "/colleges/baylor-university/campus-800.webp",
    "srcMid": "/colleges/baylor-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/baylor-university/og.jpg",
    "title": "Baylor University June 2016 18 (Founders Mall and Pat Neff Hall)",
    "author": "Michael Barera",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABaylor_University_June_2016_18_(Founders_Mall_and_Pat_Neff_Hall).jpg",
    "read": "2026-10-01"
};

export default photo;
